<div class="ds-grid ds-grid--2">
	<!-- Basic Slider (default, with input) -->
	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Basic Slider</h3>
			<p class="ds-example__header-subtitle">Default slider with editable input field</p>
		</div>
		<div class="ds-example__content">
			<eif-custom-slider
				[label]="'Percentage'"
				[min]="0"
				[max]="100"
				[step]="1"
				[value]="basicValue"
				[valueSuffix]="'%'"
				(valueChange)="onSliderChange('basic', $event)">
			</eif-custom-slider>
		</div>
		<div class="ds-example__footer">
			<div class="ds-value">
				<div class="ds-value__label">Value:</div>
				<div class="ds-value__content">{{ basicValue }}%</div>
			</div>
		</div>
	</div>

	<!-- Slider without Input -->
	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Slider without Input</h3>
			<p class="ds-example__header-subtitle">Read-only value display, no manual input</p>
		</div>
		<div class="ds-example__content">
			<eif-custom-slider
				[label]="'Volume'"
				[min]="0"
				[max]="100"
				[step]="1"
				[value]="noInputValue"
				[valueSuffix]="'%'"
				[showInput]="false"
				[showValueDisplay]="true"
				(valueChange)="onSliderChange('noInput', $event)">
			</eif-custom-slider>
		</div>
		<div class="ds-example__footer">
			<div class="ds-value">
				<div class="ds-value__label">Value:</div>
				<div class="ds-value__content">{{ noInputValue }}%</div>
			</div>
		</div>
	</div>

	<!-- Block X to 100 (blockedFrom) -->
	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Block X to 100</h3>
			<p class="ds-example__header-subtitle">blockedFrom: blocks right side. Selectable: 0 to 5,000</p>
		</div>
		<div class="ds-example__content">
			<eif-custom-slider
				[label]="'Amount (EUR)'"
				[min]="0"
				[max]="10000"
				[blockedFrom]="5000"
				[step]="100"
				[value]="blockedFromValue"
				[valueSuffix]="'EUR'"
				[showInput]="false"
				[showValueDisplay]="true"
				(valueChange)="onSliderChange('blockedFrom', $event)">
			</eif-custom-slider>
		</div>
		<div class="ds-example__footer">
			<div class="ds-value">
				<div class="ds-value__label">Value:</div>
				<div class="ds-value__content">{{ blockedFromValue | currencyFormatter }} EUR</div>
			</div>
		</div>
	</div>

	<!-- Block 0 to X (blockedTo) -->
	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Block 0 to X</h3>
			<p class="ds-example__header-subtitle">blockedTo: blocks left side. Selectable: 20 to 100</p>
		</div>
		<div class="ds-example__content">
			<eif-custom-slider
				[label]="'Percentage'"
				[min]="0"
				[max]="100"
				[blockedTo]="20"
				[step]="1"
				[value]="blockedToValue"
				[valueSuffix]="'%'"
				[showInput]="false"
				[showValueDisplay]="true"
				(valueChange)="onSliderChange('blockedTo', $event)">
			</eif-custom-slider>
		</div>
		<div class="ds-example__footer">
			<div class="ds-value">
				<div class="ds-value__label">Value:</div>
				<div class="ds-value__content">{{ blockedToValue }}%</div>
			</div>
		</div>
	</div>

	<!-- Block both sides (blockedTo + blockedFrom) -->
	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Block Both Sides</h3>
			<p class="ds-example__header-subtitle">blockedTo + blockedFrom: selectable 20 to 80 only</p>
		</div>
		<div class="ds-example__content">
			<eif-custom-slider
				[label]="'Range'"
				[min]="0"
				[max]="100"
				[blockedTo]="20"
				[blockedFrom]="80"
				[step]="1"
				[value]="blockedBothValue"
				[valueSuffix]="'%'"
				[showInput]="true"
				(valueChange)="onSliderChange('blockedBoth', $event)">
			</eif-custom-slider>
		</div>
		<div class="ds-example__footer">
			<div class="ds-value">
				<div class="ds-value__label">Value:</div>
				<div class="ds-value__content">{{ blockedBothValue }}%</div>
			</div>
		</div>
	</div>

	<!-- Slider with Icon and Tooltip -->
	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">With Icon & Tooltip</h3>
			<p class="ds-example__header-subtitle">Includes information icon and tooltip</p>
		</div>
		<div class="ds-example__content">
			<eif-custom-slider
				[label]="'Risk Level'"
				[icon]="'fa-solid fa-info-circle'"
				[tooltip]="'Adjust the risk level for your investment'"
				[min]="0"
				[max]="100"
				[step]="5"
				[value]="iconValue"
				[valueSuffix]="'%'"
				[showInput]="true"
				(valueChange)="onSliderChange('icon', $event)">
			</eif-custom-slider>
		</div>
		<div class="ds-example__footer">
			<div class="ds-value ds-value--info">
				<div class="ds-value__label">Value:</div>
				<div class="ds-value__content">{{ iconValue }}%</div>
			</div>
		</div>
	</div>

	<!-- Disabled Slider -->
	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Disabled State</h3>
			<p class="ds-example__header-subtitle">Cannot be modified</p>
		</div>
		<div class="ds-example__content">
			<eif-custom-slider
				[label]="'Locked Value'"
				[min]="0"
				[max]="100"
				[step]="1"
				[value]="disabledValue"
				[valueSuffix]="'%'"
				[disabled]="true"
				[showInput]="true">
			</eif-custom-slider>
		</div>
		<div class="ds-example__footer">
			<div class="ds-value ds-value--disabled">
				<div class="ds-value__label">Value:</div>
				<div class="ds-value__content">{{ disabledValue }}%</div>
			</div>
		</div>
	</div>

	<!-- Loading State -->
	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Loading State</h3>
			<p class="ds-example__header-subtitle">Shows spinner while fetching bounds</p>
		</div>
		<div class="ds-example__content">
			<eif-custom-slider
				[label]="'Loading...'"
				[min]="0"
				[max]="100"
				[step]="1"
				[value]="loadingValue"
				[valueSuffix]="'%'"
				[loading]="true"
				[showInput]="false"
				[showValueDisplay]="true"
				(valueChange)="onSliderChange('loading', $event)">
			</eif-custom-slider>
		</div>
		<div class="ds-example__footer">
			<div class="ds-value">
				<div class="ds-value__label">Value:</div>
				<div class="ds-value__content">{{ loadingValue }}%</div>
			</div>
		</div>
	</div>

	<!-- Decimal Step -->
	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Decimal Step</h3>
			<p class="ds-example__header-subtitle">Fine-grained control with 0.1 step</p>
		</div>
		<div class="ds-example__content">
			<eif-custom-slider
				[label]="'Precision'"
				[min]="0"
				[max]="100"
				[step]="0.1"
				[maxDecimals]="1"
				[value]="percentageValue"
				[valueSuffix]="'%'"
				[showInput]="true"
				(valueChange)="onSliderChange('percentage', $event)">
			</eif-custom-slider>
		</div>
		<div class="ds-example__footer">
			<div class="ds-value">
				<div class="ds-value__label">Value:</div>
				<div class="ds-value__content">{{ percentageValue }}%</div>
			</div>
		</div>
	</div>

	<!-- Slider with Custom Min/Max Labels -->
	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">With Custom Min/Max Labels</h3>
			<p class="ds-example__header-subtitle">Includes custom min and max labels</p>
		</div>
		<div class="ds-example__content">
			<eif-custom-slider
				[label]="'Pollution Level'"
				[icon]="'fa-solid fa-info-circle'"
				[tooltip]="'Adjust the pollution level'"
				[min]="0"
				[max]="100"
				[minLabel]="'Healthy'"
				[maxLabel]="'Hazardous'"
				[step]="5"
				[value]="pollutionValue"
				[valueSuffix]="'%'"
				[showInput]="true"
				(valueChange)="onSliderChange('pollution', $event)">
			</eif-custom-slider>
		</div>
		<div class="ds-example__footer">
			<div class="ds-value ds-value--info">
				<div class="ds-value__label">Value:</div>
				<div class="ds-value__content">{{ pollutionValue }}%</div>
			</div>
		</div>
	</div>

	<!-- No Range State -->
	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">No Range</h3>
			<p class="ds-example__header-subtitle">When max &lt;= min, shows no-range message</p>
		</div>
		<div class="ds-example__content">
			<eif-custom-slider
				[label]="'Unavailable'"
				[min]="100"
				[max]="100"
				[value]="100"
				[valueSuffix]="'%'"
				[noRangeMessage]="'No adjustable range available'"
				[showNoRange]="true">
			</eif-custom-slider>
		</div>
		<div class="ds-example__footer">
			<div class="ds-value ds-value--disabled">
				<div class="ds-value__label">State:</div>
				<div class="ds-value__content">No range (max = min)</div>
			</div>
		</div>
	</div>

	<!-- Slider with Validation -->
	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">With Validation</h3>
			<p class="ds-example__header-subtitle">Required value greater than 0, validate on button</p>
		</div>
		<div class="ds-example__content">
			<eif-custom-slider
				#validationSlider
				[label]="'Required Amount'"
				[min]="0"
				[max]="100"
				[step]="1"
				[value]="validatedValue"
				[valueSuffix]="'units'"
				[validationRules]="validationRules"
				[showInput]="true"
				(valueChange)="onSliderChange('validated', $event)"
				(validationChange)="onValidationChange($event)">
			</eif-custom-slider>
			<eif-custom-button
				[text]="'Validate'"
				[type]="'button'"
				[size]="'small'"
				[preIcon]="'fa-solid fa-check'"
				(action)="validationSlider.validate()">
			</eif-custom-button>
		</div>
		<div class="ds-example__footer">
			<div class="ds-value">
				<div class="ds-value__label">Value:</div>
				<div class="ds-value__content">{{ validatedValue }} units</div>
			</div>
			<div class="ds-value ds-mt-1">
				<div class="ds-value__label">Valid:</div>
				<div class="ds-value__content">{{ validationValid ? 'Yes' : 'No' }}</div>
			</div>
		</div>
	</div>
</div>
